import bookingService from "@/platforms/supplier/services/bookingService";
import teamService from "@/platforms/supplier/services/teamService";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

export const useDivertSupplierModal = (
  isOpen,
  onClose,
  bookingData,
  onSuccess,
) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (isOpen) {
      fetchTeamMembers();
    }
  }, [isOpen]);

  const fetchTeamMembers = async () => {
    setLoading(true);
    try {
      const response = await teamService.getTeamMembersWithBookingAccess();
      if (response.data && response.data.team_members) {
        setTeamMembers(response.data.team_members);
      }
    } catch (error) {
      console.error("Error fetching team members:", error);
      toast.error("Failed to load team members");
    } finally {
      setLoading(false);
    }
  };

  const handleDivert = async () => {
    if (!selectedSupplier) {
      toast.error("Please select a supplier");
      return;
    }

    if (!bookingData?.id) {
      toast.error("Booking ID not found");
      return;
    }

    setSending(true);
    try {
      await bookingService.divertBooking(
        bookingData.id,
        selectedSupplier.email,
        selectedSupplier.full_name ||
          selectedSupplier.business_name ||
          selectedSupplier.email,
        reason.trim() || "Booking diversion requested",
      );

      toast.success("Booking diversion request sent successfully");
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (error) {
      console.error("Error diverting booking:", error);
      toast.error(
        error.response?.data?.detail || "Failed to send diversion request",
      );
    } finally {
      setSending(false);
    }
  };

  return {
    teamMembers,
    reason,
    setReason,
    loading,
    handleDivert,
    selectedSupplier,
    setSelectedSupplier,
    sending,
  };
};
